export const LogoImg = require("../Assets/images/logo.png");
export const lightLogoImg = require("../Assets/images/logo-light.png");
export const HomeBanner = require("../Assets/images/home-banner.jpg");
export const bannerCircle = require("../Assets/images/banner-circle-img.png");
export const AppleAppStore = require("../Assets/images/app-store-logo.png");
export const GooglePlayStore = require("../Assets/images/play-store-img.png");
export const defaultImg = require("../Assets/images/default-img.jpg");

export const Sec4Slider1 = require("../Assets/images/slider-img-1.png");
export const Sec4Slider2 = require("../Assets/images/slider-img-2.png");
export const Sec4Slider3 = require("../Assets/images/slider-img-3.png");

export const Sec3Img1 = require("../Assets/images/section-3-img-1.jpg");
export const Sec3Img2 = require("../Assets/images/section-3-img-2.jpg");
export const Sec3Img3 = require("../Assets/images/section-3-img-3.jpg");

export const galleryImg1 = require("../Assets/images/gallery-img-1.png");
export const galleryImg2 = require("../Assets/images/gallery-img-2.png");
export const galleryImg3 = require("../Assets/images/gallery-img-3.png");
export const galleryImg4 = require("../Assets/images/gallery-img-4.png");
export const galleryImg5 = require("../Assets/images/gallery-img-5.png");
export const galleryImg6 = require("../Assets/images/gallery-img-6.png");

export const section1Img1 = require("../Assets/images/section-1-img.png");
export const section1Img2 = require("../Assets/images/section-1-img-2.png");
export const defaultUserImg = require("../Assets/images/default-user-img.png");
export const dummyAudio = require("../Assets/dummy_audio.mp3");

export const spaceListImg1 = require("../Assets/images/space-list-img-1.png");
export const spaceListImg2 = require("../Assets/images/space-list-img-2.png");
export const spaceListImg3 = require("../Assets/images/space-list-img-3.png");
export const spaceListImg4 = require("../Assets/images/space-list-img-4.png");
export const spaceListImg5 = require("../Assets/images/space-list-img-5.png");
export const spaceListImg6 = require("../Assets/images/space-list-img-6.png");
export const rightAngleImg = require("../Assets/images/right-angle.png");

export const bigSliderImg1 = require("../Assets/images/big-slider-img-1.png");

export const aboutActivityIcon = require("../Assets/images/about-activity-icon.png");
export const aboutDrinksIcon = require("../Assets/images/about-drinks-icon.png");
export const aboutFoodsIcon = require("../Assets/images/about-foods-icon.png");
export const aboutFurnitureIcon = require("../Assets/images/about-furniture-icon.png");
export const aboutHostRulesIcon = require("../Assets/images/about-host-rules-icon.png");
export const aboutMusicIcon = require("../Assets/images/about-music-icon.png");
export const aboutParkingIcon = require("../Assets/images/about-parking-icon.png");
export const aboutRestroomIcon = require("../Assets/images/about-restroom-icon.png");
export const aboutRulesIcon = require("../Assets/images/about-rules-icon.png");

export const featuresRestRooms = require("../Assets/images/features-restrooms.png");
export const featuresAvIcon = require("../Assets/images/features-av-icon.png");
export const featuresChairsIcon = require("../Assets/images/features-chairs-icon.png");
export const featuresKichensIcon = require("../Assets/images/features-kichen-icon.png");
export const featuresMicIcon = require("../Assets/images/features-mic-icon.png");
export const featuresOutdoorAreaIcon = require("../Assets/images/features-outdoor-area-icon.png");
export const featuresSoundproofIcon = require("../Assets/images/features-soundproof-icon.png");
export const featuresSpeakersIcon = require("../Assets/images/features-speakers-icon.png");
export const featuresTablesIcon = require("../Assets/images/features-tables-icon.png");
export const featuresTransportIcon = require("../Assets/images/features-transport-icon.png");
export const featuresWheelchairIcon = require("../Assets/images/features-wheelchair-icon.png");
export const featuresWifiIcon = require("../Assets/images/features-wifi-icon.png");
export const googleIconImg = require("../Assets/images/google-icon-img.png");

export const spaceTypeImg = require("../Assets/images/space-type-image.png");
export const uploadedImg1 = require("../Assets/images/uploaded-img-1.png");
export const uploadedImg2 = require("../Assets/images/uploaded-img-2.png");
export const uploadedImg3 = require("../Assets/images/uploaded-img-3.png");

export const adminMenuDashboardIcon = require("../Assets/images/dashboard-icon.png");
export const adminMenuPropertyIcon = require("../Assets/images/property-icon.png");
export const adminMenuInvoiceIcon = require("../Assets/images/invoice-icon.png");
export const adminMenuMessageIcon = require("../Assets/images/message-icon.png");
export const adminMenuNotificationIcon = require("../Assets/images/notification-icon.png");
export const adminMenuSettingsIcon = require("../Assets/images/settings-icon.png");
export const adminMenuMoonIcon = require("../Assets/images/moon-icon.png");
